import React from 'react';
import PropTypes from 'prop-types';

import { getBonus } from '~helpers/getters';
import styles from './bonus.module.scss';

export default function Bonus({ item, tracker, splitBy = '+', feSeparator = '+' }) {
  const isInoperative = item?.status === 'inactive';
  let oneLiner = getBonus(tracker, item);
  if (!oneLiner) {
    oneLiner = getBonus('main', item);
  }
  if (!oneLiner) {
    return <></>;
  }

  let mainLine = null;
  let secondLine = null;
  if (oneLiner?.one_liner !== null && oneLiner?.one_liner.includes(splitBy)) {
    mainLine = oneLiner?.one_liner.split(splitBy)[0];
    secondLine = oneLiner?.one_liner.split(splitBy)[1];
  } else {
    mainLine = oneLiner?.one_liner;
  }

  return (
    <>
      {!isInoperative && mainLine && <span className={styles.firstPart || ''}>{mainLine}</span>}
      {!isInoperative && secondLine && (
        <span className={styles.secondPart || ''}>{`${feSeparator}${secondLine}`}</span>
      )}
    </>
  );
}

Bonus.propTypes = {
  item: PropTypes.shape({
    status: PropTypes.string,
  }),
  tracker: PropTypes.string,
  splitBy: PropTypes.string,
  feSeparator: PropTypes.string,
};
